@import (reference) '../../../../../constants/spacing.module.less';

.wrapper {
  width: 100%;
  gap: @space-8;
}

.recommendation-field {
  &:first-of-type {
    margin-top: @space-8;
    padding-top: @space-8;
    border-top: 1px solid var(--default--border-color--12);
  }
}
